import { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import CryptoJS from "crypto-js";
import { normalizeInterviewTypeKey, isRecruitmentType } from "../utils/interviewType";
import { saveInterviewFormInicial, fetchFormularioInicialConfig } from "../services/interviewService";

export default function FormContainer({setShowChat, user, setUser,  playBackgroundVideo}) {
    const [sectors, setSectors] = useState([]);
    const [isTextSector, setIsTextSector] = useState(false);
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [privacyAccepted, setPrivacyAccepted] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [formError, setFormError] = useState('');
    const [autoOpenLegalDocs, setAutoOpenLegalDocs] = useState({
        terms: true,
        privacy: true,
    });
    const originalUserRef = useRef(null);
    const fetchedConfigCompanyRef = useRef('');
    const resolveRouteInterviewType = () => {
        const pathname = window.location.pathname || '';
        const routeMatch = pathname.match(/^\/([^/]+)\/([^/]+)\/([^/]+)\/entrevista\/([^/]+)$/);
        return routeMatch ? routeMatch[2] : '';
    };
    const recruitmentFlow = isRecruitmentType(user?.entrevista || resolveRouteInterviewType());
    const normalizedCompany = (user?.company || '').toString().trim().toLowerCase();
    const leadershipValue = ((user?.liderança ?? user?.lideranca) || '').toString();

    const normalizeCompanyValue = (value = '') => (value || '').toString().trim();

    const resolveCompanyOptionValue = (value = '') => {
        const normalized = normalizeCompanyValue(value);
        if (!normalized) return '';
        const match = (companies || []).find((item) => normalizeCompanyValue(item).toLowerCase() === normalized.toLowerCase());
        return match || normalized;
    };

    const resolvedCompanySelection = resolveCompanyOptionValue(user.empresa || '');
    const selectedCompanyValue = resolvedCompanySelection || (companies[0] || '');

    const chatUp = async  (e) => {
        e.preventDefault();
        setFormError('');

        if (recruitmentFlow && !user.email && !user.celular) {
            setFormError('Informe pelo menos E-mail ou Telefone para continuar.');
            return;
        }

        const isComplianceFlow = !recruitmentFlow;
        const enforceComplianceFields = isComplianceFlow && normalizedCompany !== 'materdei';
        if (enforceComplianceFields) {
            const empresa = resolveCompanyOptionValue(user.empresa || '');
            const setor = (user.setor || '').toString().trim();
            const cargo = (user.cargo || '').toString().trim();
            const lideranca = ((user.liderança ?? user.lideranca) || '').toString().trim();
            if (!empresa || !setor || !cargo || !lideranca) {
                const faltando = [];
                if (!empresa) faltando.push('empresa');
                if (!setor) faltando.push('setor');
                if (!cargo) faltando.push('cargo');
                if (!lideranca) faltando.push('liderança');
                setFormError(`No compliance, preencha: ${faltando.join(', ')}.`);
                return;
            }
        }

         try {
            const interviewType = normalizeInterviewTypeKey(user.entrevista || 'pesquisa-de-compliance');

            if (user.company && user.denuncia && user.entrevistaId) {
                // STG6/RS6: isso era um setDoc() direto do client no path LEGADO
                // (cliente/{company}/...) — a página pública roda sem Firebase Auth
                // de propósito, então um candidato/entrevistado real sempre batia em
                // permission-denied aqui (silenciosamente, o catch abaixo deixa
                // seguir pro chat mesmo assim), e o path legado nem é lido por mais
                // nada no sistema atual. "setor"/"cargo"/"tempoEmpresa" (obrigatórios
                // no compliance — ver enforceComplianceFields acima) nunca chegavam
                // no Firestore de verdade. Corrigido reaproveitando o mesmo callable
                // server-side dos outros writes de entrevista pública (token na URL).
                const normalize = (val) => (val ?? '').toString().trim();
                const original = originalUserRef.current || {};
                const normalizedUser = {
                    ...user,
                    matricula: user.numeromatricula || user.matricula || '',
                };
                const normalizedOriginal = {
                    ...original,
                    matricula: original.matricula || '',
                };
                const fields = [
                    'nome',
                    'nomesocial',
                    'cpf',
                    'matricula',
                    'empresa',
                    'setor',
                    'cargo',
                    'liderança',
                    'email',
                    'celular',
                    'tempoEmpresa',
                    'vinculoEmpregaticio',
                ];

                const observacoesCampos = fields.reduce((acc, key) => {
                    const before = normalize(normalizedOriginal[key]);
                    const after = normalize(normalizedUser[key]);
                    if (before !== after && (before || after)) {
                        acc[key] = { original: before, novo: after };
                    }
                    return acc;
                }, {});

                const accessToken = (new URLSearchParams(window.location.search).get('t') || '').toString().trim();
                const formData = {
                    inicioEntrevista: new Date().toISOString(),
                    status: 'em_andamento',
                    isFinished: false,
                    finalEntrevista: null,
                    nome: user.nome || '',
                    nomesocial: user.nomesocial || '',
                    cpf: user.cpf || '',
                    matricula: user.numeromatricula || user.matricula || '',
                    empresa: recruitmentFlow ? '' : resolveCompanyOptionValue(user.empresa || ''),
                    setor: recruitmentFlow ? '' : (user.setor || ''),
                    cargo: recruitmentFlow ? '' : (user.cargo || ''),
                    liderança: recruitmentFlow ? '' : ((user.liderança ?? user.lideranca) || ''),
                    email: user.email || '',
                    celular: user.celular || '',
                    tempoEmpresa: recruitmentFlow ? '' : (user.tempoEmpresa || ''),
                    vinculoEmpregaticio: recruitmentFlow ? '' : (user.vinculoEmpregaticio || ''),
                    ...(Object.keys(observacoesCampos).length ? { observacoesCampos } : {})
                };

                await saveInterviewFormInicial({
                    company: user.company,
                    interviewTypeKey: interviewType,
                    denuncia: user.denuncia,
                    entrevistaId: user.entrevistaId,
                    data: formData,
                    accessToken
                });
            } else {
                console.warn("Dados incompletos para salvar formClicked:", user);
            }
        } catch (error) {
            console.error("Erro ao salvar formClicked:", error);
        }

        setShowChat(true);
        playBackgroundVideo();
    }

    const getUrlParams = () => {
        const params = new URLSearchParams(window.location.search);
        const encryptedData = params.get("data");
        const pathname = window.location.pathname || '';
        const routeMatch = pathname.match(/^\/([^/]+)\/([^/]+)\/([^/]+)\/entrevista\/([^/]+)$/);
        const routeParams = routeMatch
            ? {
                company: routeMatch[1],
                entrevista: routeMatch[2],
                denuncia: routeMatch[3],
                entrevistaId: routeMatch[4],
            }
            : {};
        const mergeWithRouteDefaults = (payload = {}) => {
            const resolved = { ...(payload || {}) };
            for (const key of ['company', 'entrevista', 'denuncia', 'entrevistaId']) {
                const current = (resolved[key] ?? '').toString().trim();
                const routeValue = (routeParams[key] ?? '').toString().trim();
                if (!current && routeValue) {
                    resolved[key] = routeValue;
                }
            }
            return resolved;
        };

        if (encryptedData) {
            try {
                const secretKey = "due-prd";
                const decodedData = decodeURIComponent(encryptedData);
                const decryptedBase64 = CryptoJS.AES.decrypt(decodedData, secretKey).toString(CryptoJS.enc.Utf8);
                const decryptedString = atob(decryptedBase64);
                const decryptedParams = JSON.parse(decryptedString);

                const companyValue =
                    decryptedParams.company && decryptedParams.company._value
                        ? decryptedParams.company._value
                        : decryptedParams.company;

                return mergeWithRouteDefaults({
                    ...decryptedParams,
                    company: companyValue || decryptedParams.company || '',
                });
            } catch (e) {
                console.error("Erro ao descriptografar os parâmetros da URL", e);
            }
        }

        const fallbackParams = {
            denuncia: params.get('denuncia') || '',
            entrevista: params.get('entrevista') || '',
            nome: '',
            cpf: '',
            numeromatricula: '',
            empresa: '',
            setor: '',
            cargo: '',
            liderança: '',
            email: '',
            celular: '',
            company: params.get('company')  || ''
        };
        return mergeWithRouteDefaults(fallbackParams);
    }

    // STG6: as 3 funções abaixo liam de `cliente/{company}/...` (path LEGADO)
    // — o setor/empresa associada/config de notificações de uma conta real
    // hoje só existem no path CANÔNICO (`accounts/acc_{slug}/...`), escrito
    // por telas de admin já em produção (RegisterSetores.vue,
    // ReportSettings.vue) e lido com sucesso em outros lugares do sistema
    // (PainelExecutivo.vue usa `accounts/acc_{slug}/associated_companies`).
    // Resultado prático: pra qualquer conta que não seja a legada "materdei",
    // os dropdowns "Empresa que trabalha"/"Setor que trabalha" vinham SEMPRE
    // vazios (sem nenhuma opção real pra escolher) — como "empresa" é
    // obrigatório fora do materdei (enforceComplianceFields acima), o
    // formulário ficava impossível de enviar pra um cliente real.
    // Fonte única pras 3 leituras acima — um callable só (getFormularioInicialConfig),
    // já que a página pública roda sem Firebase Auth e nem o path canônico
    // pode ser lido direto do client (accounts/{id} exige isAccountMember).
    const fetchFormularioConfig = async (company) => {
        const companyValue = (company && company.__v_isRef) ? company._value : company;
        try {
            const result = await fetchFormularioInicialConfig({ company: companyValue });
            if (result?.autoOpenLegalDocs) {
                setAutoOpenLegalDocs(result.autoOpenLegalDocs);
            }
            if (recruitmentFlow) return;

            if (companyValue === "materdei") {
                setIsTextSector(true);
            } else if (Array.isArray(result?.setores) && result.setores.length) {
                setSectors(result.setores);
            }

            const associatedCompanies = Array.isArray(result?.associatedCompanies) ? result.associatedCompanies : [];
            const baseCompanies = companyValue.toLowerCase() === "materdei"
                ? [...associatedCompanies, "Outros"]
                : [normalizeCompanyValue(companyValue.toUpperCase()), ...associatedCompanies, "Outros"];
            const uniqueCompanies = Array.from(new Set(baseCompanies.map((item) => normalizeCompanyValue(item)).filter(Boolean)));
            setCompanies(uniqueCompanies);
        } catch (error) {
            console.error("Erro ao buscar configuração do formulário inicial:", error);
            setAutoOpenLegalDocs({ terms: true, privacy: true });
        }
    };

    // Set initial state from URL parameters
    useEffect(() => {
        // Bug pré-existente encontrado testando o formulário de verdade (não
        // introduzido por essa rodada, só ficou caro o bastante pra travar o
        // navegador): esse efeito tinha `user` na dependência, e
        // `setUser(prev => ({...prev, ...}))` SEMPRE devolve um objeto NOVO
        // (spread), mesmo quando nenhum campo muda de verdade — React não
        // sabe que "nada mudou" só olhando a referência, então recria o
        // componente, o que dispara o efeito de novo, que chama setUser nova
        // de novo... um loop infinito de re-render. Antes, cada volta do loop
        // só fazia 3 leituras baratas de Firestore (rápido o bastante pra não
        // travar nada visivelmente); com fetchFormularioConfig (uma Cloud
        // Function, com round-trip de rede de verdade) no lugar, o loop
        // estourava `ERR_INSUFFICIENT_RESOURCES` em poucos segundos.
        // Corrigido rodando isso só uma vez, no mount (os dados vêm da URL,
        // que não muda durante a sessão — não tinha motivo real pra
        // depender de `user`).
        const initialUser = getUrlParams();
        const fillMissing = (current = {}, incoming = {}) => {
            const merged = { ...(current || {}) };
            Object.entries(incoming || {}).forEach(([key, value]) => {
                const currentValue = (merged[key] ?? '').toString().trim();
                const incomingValue = (value ?? '').toString().trim();
                if (!currentValue && incomingValue) {
                    merged[key] = value;
                }
            });
            return merged;
        };

        setUser(prev => fillMissing(prev, initialUser));

        const effectiveCompany = initialUser.company;
        if (effectiveCompany && fetchedConfigCompanyRef.current !== effectiveCompany) {
            fetchedConfigCompanyRef.current = effectiveCompany;
            fetchFormularioConfig(effectiveCompany);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (recruitmentFlow) return;
        if (!Array.isArray(companies) || companies.length === 0) return;

        const firstAvailableCompany = normalizeCompanyValue(companies[0]);
        const resolved = resolveCompanyOptionValue(user.empresa || '');
        if (resolved) return;
        if (!firstAvailableCompany) return;

        setUser((prev) => {
            const currentResolved = resolveCompanyOptionValue(prev?.empresa || '');
            if (currentResolved) return prev;
            return { ...prev, empresa: firstAvailableCompany };
        });
    }, [companies, recruitmentFlow, setUser, user.empresa]);

    useEffect(() => {
        if (!originalUserRef.current && user && user.entrevistaId) {
            originalUserRef.current = {
                nome: user.nome || '',
                nomesocial: user.nomesocial || '',
                cpf: user.cpf || '',
                matricula: user.numeromatricula || user.matricula || '',
                empresa: user.empresa || '',
                setor: user.setor || '',
                cargo: user.cargo || '',
                liderança: (user.liderança ?? user.lideranca) || '',
                email: user.email || '',
                celular: user.celular || '',
                tempoEmpresa: user.tempoEmpresa || '',
                vinculoEmpregaticio: user.vinculoEmpregaticio || '',
            };
        }
    }, [user]);

    return (
        <FormContainerPage>
            <FormPage onSubmit={chatUp}>
                <h1>Bem vindo(a), por favor preencha o <span>formulário inicial</span></h1>
                <label>Nome Completo: </label>
                <input
                    type="text"
                    value={user.nome || ''}
                    onChange={e => {
                        setUser({ ...user, nome: e.target.value })
                    }}
                    required
                />
                <label>{recruitmentFlow ? "CPF (opcional):" : (user.company === "materdei" ? "Número de Matrícula:" : "CPF:")}</label>
                <input
                    type="text"
                    value={(!recruitmentFlow && user.company === "materdei") ? (user.numeromatricula || '') : (user.cpf || '')}
                    onChange={e => {
                        setUser(prevUser => ({
                            ...prevUser,
                            ...((!recruitmentFlow && user.company === "materdei")
                                ? { numeromatricula: e.target.value }
                                : { cpf: e.target.value })
                        }));
                    }}
                    required={!recruitmentFlow}
                />
                <label>E-mail: </label>
                <input
                    type="email"
                    value={user.email || ''}
                    onChange={e => {
                        setUser({ ...user, email: e.target.value })
                    }}
                />
                {recruitmentFlow && (
                    <>
                        <label>Telefone (com DDD): </label>
                        <input
                            type="text"
                            value={user.celular || ''}
                            onChange={e => {
                                setUser({ ...user, celular: e.target.value })
                            }}
                        />
                    </>
                )}
                {recruitmentFlow ? (
                    <></>
                ) : (
                    <>
                        <label>Empresa que trabalha: </label>
                        <select
                            value={selectedCompanyValue}
                            onChange={e => {
                                setUser({ ...user, empresa: normalizeCompanyValue(e.target.value) });
                            }}
                            required={normalizedCompany !== 'materdei'}
                        >
                            {!companies.length && <option value="">Selecione...</option>}
                            {companies.map((company, index) => (
                                <option key={index} value={company}>
                                    {company}
                                </option>
                            ))}
                        </select>
                        <label>Setor que trabalha: </label>
                        {isTextSector ? (
                            <input
                                type="text"
                                value={user.setor || ''}
                                onChange={e => {
                                    setUser({ ...user, setor: e.target.value });
                                }}
                                required={normalizedCompany !== 'materdei'}
                            />
                        ) : (
                            <select
                                value={user.setor || ''}
                                onChange={e => {
                                    setUser({ ...user, setor: e.target.value })
                                }}
                                required={normalizedCompany !== 'materdei'}
                            >
                                <option value="Sem setor">Sem Setor</option>
                                {sectors.map((sector, index) => (
                                    <option key={index} value={sector}>{sector}</option>
                                ))}
                            </select>
                        )}
                        <label>Cargo</label>
                        <input
                            type="text"
                            value={user.cargo || ''}
                            onChange={e => {
                                setUser({ ...user, cargo: e.target.value })
                            }}
                            required={normalizedCompany !== 'materdei'}
                        />
                        <label>Nome completo da liderança:</label>
                        <input
                            type="text"
                            value={leadershipValue || ''}
                            onChange={e => {
                                setUser({ ...user, liderança: e.target.value, lideranca: e.target.value })
                            }}
                            required={normalizedCompany !== 'materdei'}
                        />
                    </>
                )}
                {!!formError && <small style={{ color: '#C62828', marginBottom: '8px' }}>{formError}</small>}
                <div style={{ display: 'flex', alignItems: 'center', marginLeft: '10px' }}>
                    <input
                        type="checkbox"
                        checked={termsAccepted}
                        onChange={e => {
                            setTermsAccepted(e.target.checked);
                            if (
                                e.target.checked
                                && (user.company || "").toLowerCase() !== "materdei"
                                && autoOpenLegalDocs.terms
                            ) {
                                window.open("https://due-prd.web.app/termos-de-uso.pdf#toolbar=0", "_blank");
                            }
                        }}
                        style={{ width: '20px', margin: '0' }}
                        required
                    />
                    <label style={{ marginBottom: '0', marginLeft: '10px', fontSize: '16px' }}>
                        Li, compreendi e concordo com os{' '}
                        <a
                            href="https://due-prd.web.app/termos-de-uso.pdf#toolbar=0"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ fontWeight: 'bold', color: 'blue', textDecoration: 'none' }}
                        >
                            Termos de Uso
                        </a>
                    </label>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '15px', marginLeft: '10px' }}>
                    <input
                        type="checkbox"
                        checked={privacyAccepted}
                        onChange={e => {
                            setPrivacyAccepted(e.target.checked);
                            if (
                                e.target.checked
                                && (user.company || "").toLowerCase() !== "materdei"
                                && autoOpenLegalDocs.privacy
                            ) {
                                window.open("https://due-prd.web.app/politica-de-privacidade.pdf#toolbar=0", "_blank");
                            }
                        }}
                        style={{ width: '20px', margin: '0' }}
                        required
                    />
                    <label style={{ marginBottom: '0', marginLeft: '10px', fontSize: '16px' }}>
                        Li, compreendi e concordo com a{' '}
                        <a
                            href="https://due-prd.web.app/politica-de-privacidade.pdf#toolbar=0"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ fontWeight: 'bold', color: 'blue', textDecoration: 'none' }}
                        >
                            Política de Privacidade
                        </a>
                    </label>
                </div>
                <SendFormButton type="submit" disabled={!termsAccepted || !privacyAccepted}>
                    <p>Enviar</p>
                </SendFormButton>
            </FormPage>
        </FormContainerPage>
    )
}

const FormContainerPage = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    min-height: 100vh;
    padding: 20px 16px 40px;
    overflow-y: auto;
    box-sizing: border-box;
`

const FormPage = styled.form`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 4px 8px 7px #BACCDE89;
    border: 1px solid #D1D1D1;
    border-radius: 16px;
    padding: 30px 24px 24px;
    background: #fff;
    width: 100%;
    max-width: 520px;
    h1 {
        font-family: 'Roboto', sans-serif;
        font-size: 24px;
        font-weight: 400;
        margin-bottom: 40px;
        width: 100%;
        text-align: center;
        span {
            font-weight: 700;
        }
    }

    label {
        font-family: 'Roboto', sans-serif;
        font-size: 18px;
        font-weight: 400;
        margin-bottom: 10px;
    }
    
    select {
        width: 320px;
        height: 30px;
        background-color: #FFFFFF;
        border: 1px solid #707070;
        border-radius: 12px;
        margin-bottom: 20px;
        padding-left: 15px;
    }

    input {
        width: 305px;
        height: 30px;
        background-color: #FFFFFF;
        border: 1px solid #707070;
        border-radius: 12px;
        margin-bottom: 20px;
        padding-left: 15px;
    }
`

const SendFormButton = styled.button`
    margin-top: 20px;
    width: 340px;
    height: 64px;
    background-color: ${props => props.disabled ? '#B5B7BE' : '#05C302'};
    box-shadow: 4px 4px 6px #BACCDE89;
    border: none;
    border-radius: 16px;
    color: #fff;
    font-family: 'Roboto', sans-serif;
    font-size: 18px;
    font-weight: 400;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    transition: background-color 0.3s, cursor 0.3s;
`





